/** macOS-style window traffic-light dots — shared by Terminal & BrowserWindow. */
export default function TrafficDots() {
  return (
    <span className="flex gap-[7px]" aria-hidden="true">
      <i className="block h-[11px] w-[11px] rounded-full bg-[#ff5f57]" />
      <i className="block h-[11px] w-[11px] rounded-full bg-[#febc2e]" />
      <i className="block h-[11px] w-[11px] rounded-full bg-[#28c840]" />
    </span>
  );
}
